@use '@ingka/base/_mixins.scss' as *;
@use '@ingka/variables/style.scss' as *;
@use '../../../../constants.scss' as *;

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $space-150;
  padding: $space-200;
}

.cardInfo {
  margin-top: 1rem;
}

.loyaltyCard {
  width: 100%;
}

.inactive {
  opacity: 0.5;
}

.inactive > :global(.#{$prefix}member-card__header) {
  background-color: $colour-static-dark-grey;
  border-color: $colour-static-grey;
}

.helpText,
.errorTitle {
  margin: 0;
  align-self: start;
}

.contactUs {
  color: $colour-text-and-icon-2;
}
